<script setup>
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

defineProps({ selected: { type: Boolean, default: false } });
const meta = NODE_TYPES.end;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>Fim do fluxo. Abre a conversa pra um humano ver.</p>
  </FlowNodeCard>
</template>
